import React from 'react'

import DataTidakSesuai from 'app/PemetaanKompetensiPage/pages/DataTidakSesuai'
import PageHeader from 'app/PemetaanKompetensiPage/components/PageHeader'
import { checkDateTimeServer } from 'app/PemetaanKompetensiPage/utils'

export async function getServerSideProps() {
  const currentDateTimeServer = await checkDateTimeServer()
  return {
    props: { currentDateTimeServer }, // will be passed to the page component as props
  }
}
const DataTidakSesuaiPage = ({ currentDateTimeServer }) => {
  return <DataTidakSesuai currentDateTimeServer={currentDateTimeServer} />
}

const DataTidakSesuaiPageHeader = () => <PageHeader title="Data Tidak Sesuai" />

DataTidakSesuaiPage.layoutOpts = {
  hasHeader: true,
  className: 'text-default bg-gray-10 !max-w-full !h-full min-h-screen',
  header: DataTidakSesuaiPageHeader,
}
export default DataTidakSesuaiPage
